import { trackWorkoutPlanPageLoad } from 'analytics/trackers/workout';
import React from 'react';

import { useScreenLoadTracker } from 'hooks';

import { WorkoutPlanModule } from './WorkoutPlanModule';

export const WorkoutPlan = () => {
    useScreenLoadTracker(trackWorkoutPlanPageLoad);

    return <WorkoutPlanModule />;
};
